/* eslint-disable import/prefer-default-export */
import api from "./axios";

export async function getStage(value, user = false, all = false) {
  const response = await api.get(`/stages/${value}&${user}&${all}`);
  return response;
}

export async function postStage(stage) {
  const response = await api.post("/stages", stage);
  return response;
}

export async function deleteStage(stageId) {
  const response = await api.delete(`/stages/${stageId}`);
  return response;
}

export async function putStage(stage, stageId) {
  const response = await api.put(`/stages/${stageId}`, stage);
  return response;
}
